import { NewsDTO, NewsFlatDTO } from "../domain/models/dto/NewsDTO";
import { INewsFlat, NewsFlatCollection } from "../domain/models/News";
import { NewsService } from "../domain/services/NewsService";
import { NewsFlatMapper } from "../mappers/NewsFlatMapper";
import { BaseServiceImpl } from "./BaseServiceImpl";
import { LanguageServiceImpl } from "./LanguageServiceImpl";

export class NewsServiceImpl extends BaseServiceImpl implements NewsService {
    static _instance: NewsService;
    private readonly newsEndpoint = "/api/v1/news";

    private constructor() {
        super();
    }

    static getInstance(): NewsService {
        if (!NewsServiceImpl._instance) {
            NewsServiceImpl._instance = new NewsServiceImpl();
        }
        return NewsServiceImpl._instance;
    }

    async getAllNews(
        currentPage: number,
        currentLimit: number,
        filtersDTO: NewsDTO = {} as NewsDTO
    ): Promise<NewsFlatCollection> {
        try {
            let url = `${this.newsEndpoint}?page=${currentPage}&limit=${currentLimit}&lang=${LanguageServiceImpl.getInstance().currentLang
                }`;
            Object.entries(filtersDTO).forEach(([key, value]) => {
                if (key && value !== null && value !== undefined) {
                    url += `&${key}=${value}`;
                }
            });

            const result = await this.get<NewsFlatCollection>(url);
            return {
                ...result,
                rows: result.rows.map((dto) =>
                    new NewsFlatMapper().fromDTO(dto)
                ),
            };
        } catch (err) {
            console.log("Error in NewsServiceImpl.getAllNews");
            console.log(err);
        }
    }

    async getNewsById(id: string): Promise<INewsFlat | null> {
        try {
            if (!id) return null;

            const dto = await this.get<NewsFlatDTO>(
                `${this.newsEndpoint}/${id}?lang=${LanguageServiceImpl.getInstance().currentLang
                }`
            );
            return new NewsFlatMapper().fromDTO(dto);
        } catch (err) {
            console.log("Error in NewsServiceImpl.getNewsById");
            console.log(err);
            return null;
        }
    }
}

export function newsServiceFactory(): NewsService {
    return NewsServiceImpl.getInstance();
}
